import { render } from "./evacuation.vue?vue&type=template&id=436d3c8b&scoped=true"
import script from "./evacuation.vue?vue&type=script&lang=js"
export * from "./evacuation.vue?vue&type=script&lang=js"

import "./evacuation.vue?vue&type=style&index=0&id=436d3c8b&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-436d3c8b"]])

export default __exports__